import { TreatmentCode } from './TreatmentCode';
import { TreatmentFee } from './TreatmentFee';
import { OutPatientPrescriptionWrite } from './OutPatientPrescriptionWrite';
import { NewBorn } from './NewBorn';
import { AllergicMedicines } from './AllergicMedicines';
import { OrganDonateWrite } from './OrganDonateWrite';
import { HealthInsurance } from './HealthInsurance';
import { EmergentTelWrite } from './EmergentTelWrite';
import { PredeliveryCheckup } from './PredeliveryCheckup';
import { PatientBaseInput } from './PatientBaseInput';
import { InoculateDataWrite } from './InoculateDataWrite';
import { GetSeqNumber256 } from './GetSeqNumber256';
import { AllergicNum } from './AllergicNum';
import { TreatmentData } from './TreatmentData';
import { PrescriptionSignMultiWrite } from './PrescriptionSignMultiWrite';
import { CSHISResultWithData } from './CSHISResultWithData';
import { BasicData } from './BasicData';
import { RegisterBasic } from './RegisterBasic';
import { RegisterPrevent } from './RegisterPrevent';
import { RegisterPregnant } from './RegisterPregnant';
import { TreatmentNoNeedHPC } from './TreatmentNoNeedHPC';
import { CumulativeData } from './CumulativeData';
import { CumulativeFee } from './CumulativeFee';
import { TreatmentNeedHPC } from './TreatmentNeedHPC';
import { Prescription } from './Prescription';
import { Inoculate } from './Inoculate';
import { OrganDonate } from './OrganDonate';
import { EmergentTel } from './EmergentTel';
import { LastSeqNum } from './LastSeqNum';
import { DocIdData } from './DocIdData';
import { CSHISResult } from './CSHISResult';
import { CriticalIllnessData } from './CriticalIllnessData';
import { SeqNumber256N1 } from './SeqNumber256N1';
import { TreatNumNoICCard } from './TreatNumNoICCard';
import { UploadDataResult } from './UploadDataResult';
import { CnhiEiiApiID } from './Download';
import { VPNGetRandomXandSignX } from './VPNGetRandomXandSignX';
import { HCASignRequestData, HcaInitData } from './HcaInitData';
import { RegisterBasic2 } from './RegisterBasic2';
import { PrescriptionMain } from './PrescriptionMain';
import { PrescriptionLongTerm } from './PrescriptionLongTerm';

/**
    *
    */
export interface IVisionHIS {
    GetBasicData(): Promise<CSHISResultWithData<BasicData>>;

    /**
    * 掛號或報到時讀取基本資料
    */
    GetRegisterBasic(): Promise<CSHISResultWithData<RegisterBasic>>;

    /**
    * 預防保健掛號作業
    */
    GetRegisterPrevent(): Promise<CSHISResultWithData<RegisterPrevent>>;

    /**
    * 孕婦產前檢查掛號作業
    */
    GetRegisterPregnant(): Promise<CSHISResultWithData<RegisterPregnant>>;

    /**
    * 讀取就醫資料不需HPC卡的部分
    */
    GetTreatmentNoNeedHPC(): Promise<CSHISResultWithData<TreatmentNoNeedHPC>>;
    /** 讀取醫療費用總累計 */
    GetCumulativeFee(): Promise<CSHISResultWithData<CumulativeFee>>;
    /**
    * 讀取就醫累計資料
    */
    GetCumulativeData(): Promise<CSHISResultWithData<CumulativeData>>;

    /**
    * 讀取就醫資料需要HPC卡的部份
    */
    GetTreatmentNeedHPC(): Promise<CSHISResultWithData<TreatmentNeedHPC>>;



    /**
    * 讀取處方箋作業
    */
    ReadPrescription(): Promise<CSHISResultWithData<Prescription>>;

    /**
    * 讀取預防接種資料
    */
    GetInoculateData(): Promise<CSHISResultWithData<Inoculate>>;

    /**
    * 讀取同意器官捐贈及安寧緩和醫療註記
    */
    GetOrganDonate(): Promise<CSHISResultWithData<OrganDonate>>;

    /**
    * 讀取緊急聯絡電話資料
    */
    GetEmergentTel(): Promise<CSHISResultWithData<EmergentTel>>;

    /**
    * 讀取最近一次就醫序號
    */
    GetLastSeqNum(): Promise<CSHISResultWithData<LastSeqNum>>;

    /**
    * 讀取卡片狀態(安全模組檔)
    */
    GetCardStatusSAM(): Promise<CSHISResultWithData<string>>;

    /**
    * 讀取卡片狀態(健保IC卡)
    *   { 0 , "卡片未置入" },
        { 1 , "健保 IC 卡尚未與安全模組認證" },
        { 2 , "健保 IC 卡與安全模組認證成功" },
        { 3 , "健保 IC 卡與醫事人員卡認證成功" },
        { 4 , "健保 IC 卡 PIN 認證成功" },
        { 5 , "健保 IC 卡與健保局 IDC 認證成功" },
        { 9 , "所置入非健保 IC 卡" },
    */
    GetCardStatusHC(): Promise<CSHISResultWithData<string>>;

    /**
    * 讀取卡片狀態(醫事人員卡)
    */
    GetCardStatusHPC(): Promise<CSHISResultWithData<string>>;


    /**
    * 新生兒註記寫入作業
    */
    WriteNewBorn(data: NewBorn): Promise<CSHISResult>;



    /** 過敏藥物寫入作業 */
    WriteAllergicMedicines(data: AllergicMedicines): Promise<CSHISResultWithData<DocIdData>>;

    /**
    * 同意器官捐贈及安寧緩和醫療註記寫入作業
    */
    WriteOrganDonate(data: OrganDonateWrite): Promise<CSHISResult>;

    /**
    * 預防保健資料寫入作業
    */
    WriteHealthInsurance(data: HealthInsurance): Promise<CSHISResultWithData<string[]>>;

    /**
    * 緊急聯絡電話資料寫入作業
    */
    WriteEmergentTel(data: EmergentTelWrite): Promise<CSHISResult>;

    /**
    * 寫入產前檢查資料
    */
    WritePredeliveryCheckup(data: PredeliveryCheckup): Promise<CSHISResult>;

    /**
    * 清除產前檢查資料
    */
    DeletePredeliveryData(data: PatientBaseInput): Promise<CSHISResult>;

    /**
    * 預防接種資料寫入作業
    */
    WriteInoculateData(data: InoculateDataWrite): Promise<CSHISResult>;

    /**
    * 驗證健保IC卡之PIN值
    */
    VerifyHCPIN(pin:string): Promise<CSHISResult>;

    /**
    * 呼叫此函式後，DLL 端自行 pop-up 視窗，使用者可於讀卡機 Keypad輸入兩次 pin 碼<br />  如原先之健保卡 Pin 碼輸入功能設為停用，經呼叫此函式成功後，即啟動健保卡之 Pin 碼輸入功能。<br />  如欲變更 Pin 碼，需先呼叫 csVerifyHCPIN 輸入舊 Pin 碼成功後，再呼叫csInputHCPIN 輸入兩次新 Pin 碼。
    */
    InputHCPIN(newPin:string): Promise<CSHISResult>;

    /**
    * 停用健保IC卡之Pin碼輸入功能
    */
    DisableHCPIN(): Promise<CSHISResult>;

    /**
    * (健保IC卡卡片內容更新作業)  呼叫本函數後， CS 會自動更新下列欄位內容：  「卡片註銷註記」(HC 基本 8)<br />  「保險人代碼」(HC 健 1)<br />  「保險對象身分註記」(HC 健 2)<br />  「卡片有效期限」(HC 健 3)<br />  「重大傷病註記」第一組(HC 健 4)<br />  「重大傷病註記」第二組(HC 健 4)<br />  「重大傷病註記」第三組(HC 健 4)<br />  「重大傷病註記」第四組(HC 健 4)<br />  「重大傷病註記」第五組(HC 健 4)<br />  「重大傷病註記」第六組(HC 健 4)<br />  「就醫可用次數」(HC 健 5)<br />  「最近一次就醫序號」(HC 健 6)<br />  「就醫累計資料」第一組(HC 健 9)<br />  「就醫累計資料」第二組(HC 健 9)<br />  「Pin 碼的狀態」(enable 或 disable
    */
    UpdateHCContents(): Promise<CSHISResult>;

    /**
    * 開啟讀卡機連結埠<br />  呼叫 cshis.dll 內之任何一函數前，必須先呼叫此一函數確認讀卡機連接成功後，才可再呼叫其他函數
    */
    OpenCom(comport: number): Promise<CSHISResult>;

    /**
    * 關閉讀卡機連結埠<br />  結束所有讀卡機作業時需呼叫此一函數， 將先前開啟之讀卡機連結埠關閉
    */
    CloseCom(): Promise<CSHISResult>;

    /**
    * 讀取重大傷病註記資料
    */
    GetCriticalIllness(): Promise<CSHISResultWithData<CriticalIllnessData>>;

    /**
    * 讀取讀卡機日期時間(民國年)
    */
    GetDateTime(): Promise<CSHISResultWithData<Date>>;

    /**
    * 讀取卡片號碼(SAM)
    */
    GetCardNoSAM(): Promise<CSHISResultWithData<string>>;

    /**
    * 讀取卡片號碼(健保IC卡)
    */
    GetCardNoHC(): Promise<CSHISResultWithData<string>>;

    /**
    * 讀取卡片號碼(醫事人員卡)
    */
    GetCardNoHPC(): Promise<CSHISResultWithData<string>>;

    /**
    * 檢查健保IC卡是否設定密碼  ///
    */
    ISSetPIN(): Promise<CSHISResult>;


    /**
    * 回復就醫資料累計值---退掛
    */
    UnGetSeqNumber(pUnTreatDate: string): Promise<CSHISResult>;

    /**
    * 健保IC卡卡片內容更新作業<br />  此功能和UpdateHCContents完全相同，唯一的差異處在於本函式在完成更新健保卡後，  不對健保卡做Reset動作，故持卡人需將卡片移出再重新插入讀卡機，才能繼續進行其他  作業。<br />  UpdateHCContents 則於完成更新後，自動呼叫 Reset 指令，因此健保 IC 卡完成更新後  ，不需拔出卡片即可以直接查詢卡片內資料或進行掛號作業。
    */
    UpdateHCNoReset(): Promise<CSHISResult>;



    /**
    * 過敏藥物寫入指定欄位作業
    */
    WriteAllergicNum(data: AllergicNum): Promise<CSHISResultWithData<DocIdData>>;

    /**
    * 就醫診療資料及費用寫入作業
    */
    WriteTreatmentData(data: TreatmentData): Promise<CSHISResultWithData<DocIdData>>;



    /**
    * 多筆處方箋寫入作業-回傳簽章
    */
    WriteMultiPrescriptSign(data: PrescriptionSignMultiWrite): Promise<CSHISResultWithData<string[]>>;

    /**
    * 讀取重大傷病註記資料身分比對  本函式與 hisGetCriticalIllness 功能相同，但呼叫時要傳入 ID 和  birthday，  確認和 HC 卡為同一人時才可讀取重大傷病資料，HIS可和 hisGetCriticalIllness 擇一使用
    */
    GetCriticalIllnessID(data: PatientBaseInput): Promise<CSHISResultWithData<CriticalIllnessData>>;

    /**
    * 取得控制軟體版本
    */
    GetVersionEx(): Promise<CSHISResultWithData<number>>;

    /**
    * 提供His重置讀卡機或卡片的API (讀卡機)
    */
    SoftwareResetCR(): Promise<CSHISResult>;

    /**
    * 提供His重置讀卡機或卡片的API (安全模組)
    */
    SoftwareResetSAM(): Promise<CSHISResult>;

    /**
    * 提供His重置讀卡機或卡片的API (醫事人員卡)
    */
    SoftwareResetHPC(): Promise<CSHISResult>;

    /**
    * 提供His重置讀卡機或卡片的API (健保卡)
    */
    SoftwareResetHC(): Promise<CSHISResult>;

    /**
    * 取得就醫序號新版-就醫識別碼
    */
    GetSeqNumber256N1(args: GetSeqNumber256): Promise<CSHISResultWithData<SeqNumber256N1>>;

    /**
    * 異常掛號時 取得就醫識別碼
    */
    GetTreatNumNoICCard(patientId: string, hospCode: string): Promise<CSHISResultWithData<TreatNumNoICCard>>;

    /**
    * 在保狀態查核
    */
    QuickInsurence(cTreatItem: string): Promise<CSHISResult>;

    /**
    * 單獨取得就醫識別碼  要插入健保卡，可配合既有 HIS 運作
    */
    hisGetTreatNumICCard(pDateTime: string ) :Promise<CSHISResultWithData<string>>;

    /**
    * SAM與DC認證
    */
    VerifySAMDC(): Promise<CSHISResult>;

    /**
    * 讀取SAM院所代碼
    */
    GetHospID(): Promise<CSHISResultWithData<string>>;

    /**
    * 讀取SAM院所名稱
    */
    GetHospName(): Promise<CSHISResultWithData<string>>;

    /**
    * 讀取SAM院所簡稱
    */
    GetHospAbbName(): Promise<CSHISResultWithData<string>>;

    /**
    * 資料上傳
    */
    UploadData(pUploadFileName: string, pNumber: string): Promise<CSHISResultWithData<UploadDataResult>>;

    /**
    * (資料上傳) 增加「處方筆數」參數
    */
    //UploadDataPrec(pUploadFileName: string, pNumber: string, pPrecNumber: string): Promise<CSHISResultWithData<UploadDataPrecResult>>;

    /**
    * 檢核錯誤報表資料自動下載
    */
    //DownloadData(args: DownloadDataArg): Promise<CSHISResultWithData<string>>;

    /**
    * 取得醫事人員卡狀態
    */
    GetHPCStatus(): Promise<CSHISResultWithData<boolean>>;

    /**
    * 檢查醫事人員卡之PIN值
    */
    VerifyHPCPIN(pin:string): Promise<CSHISResult>;

    /**
    * 輸入新的醫事人員卡之PIN值
    */
    InputHPCPIN(newPin:string): Promise<CSHISResult>;

    /**
    * 解開鎖住的醫事人員卡
    */
    UnlockHPC(puk:string,newPin:string): Promise<CSHISResult>;

    /**
    * 取得醫事人員卡序號
    */
    GetHPCSN(): Promise<CSHISResultWithData<string>>;

    /**
    * 取得醫事人員卡身分證字號
    */
    GetHPCSSN(): Promise<CSHISResultWithData<string>>;

    /**
    * 取得醫事人員卡中文姓名
    */
    GetHPCCNAME(): Promise<CSHISResultWithData<string>>;

    /**
    * 取得醫事人員卡英文姓名
    */
    GetHPCENAME(): Promise<CSHISResultWithData<string>>;

    /**
    * 虛擬醫師卡登出
    */
    VHPCLogout(): Promise<CSHISResult>;

    /**
    * 進行疾病診斷碼押碼
    */
    GetICD10EnC(code: string): Promise<CSHISResultWithData<string>>;

    /**
    * 進行疾病診斷碼解押碼
    */
    GetICD10DeC(encoded: string): Promise<CSHISResultWithData<string>>;

    /**
    * 取得API版本
    */
    GetAPIVersion(): Promise<CSHISResultWithData<string>>;

    GetVPNGetRandomXAndSignX(cardType:string,serviceCode:string): Promise<CSHISResultWithData<VPNGetRandomXandSignX>>;
    GetHCACert(data:HcaInitData): Promise<CSHISResultWithData<string>>;
    GetHCASign(data:HCASignRequestData): Promise<CSHISResultWithData<string>>;
    InitializationAndCheckPasswd(passWord:string): Promise<CSHISResultWithData<HcaInitData>>;


    /** CNHIEii 資料上傳
     * @param port 整數值，健保讀卡機連接之通訊連接埠編號，起始值為0
     * @param typeCode 資料類型
     * - "03"：醫費申報資料 XML 格式
     * - "05"：預檢醫費申報資料 XML 格式
     * - "07"：醫療費用電子申復資料
     * - "09"：預檢醫療費用電子申復資料
     * - "26"：檢驗(查)每日上傳資料 XML 格式
     * @param filePath 上傳作業檔案，為完整路徑及檔名，例：C:\AP\3501200000110990913B.zip
     * @example  CNHIEiiSend(0,"03","C:\\AP\\3501200000110990913B.zip")
     */
    CNHIEiiSend(port:number,typeCode:string,filePath:string): Promise<CSHISResultWithData<CnhiEiiApiID>>;
    /** CNHIEii 提出醫療資料下載申請
     * @param port 整數值，健保讀卡機連接之通訊連接埠編號，起始值為0
     * @param typeCode 資料類型
     * - "03"：醫費申報資料檢核結果回饋資料
     * - "04"：電子轉診資料下載_回復電子轉診單
     * - "05"：預檢醫費申報資料檢核結果回饋資料
     * - "06"：抽樣回饋資料
     * - "07"：醫療費用電子申復資料檢核結果回饋資料
     * - "08"：健保醫療資訊雲端查詢批次下載作業
     * - "09"：預檢醫療費用電子申復資料檢核結果回饋資料
     * - "10"：電子轉診資料下載_開立電子轉診單
     * - "26"：檢驗(查)每日上傳資料 XML 格式檢核結果回饋資料
     * - "27"：電子轉診資料下載申請檔_管理作業 csv 下載
     * - "31"：健保醫療資訊雲端查詢批次下載作業(新格式)
     * - "33"：居家輕量藍牙就醫資料下載
     * @param filePath 下載作業需求檔案，檔案內容格式請依照「下載檔案種類」要求，為完整路徑及檔名，
     * @returns CnhiEiiApiID 作業辨識碼
     *
     * @example CNHIEiiDownload(0,"03","C:\\AP\\3501200000-1010704-001.txt")
     *
    */
    CNHIEiiDownload(port:number,typeCode:string,filePath:string): Promise<CSHISResultWithData<CnhiEiiApiID>>;
    /** CNHIEii 下載醫療資料
     * @param port 整數值，健保讀卡機連接之通訊連接埠編號，起始值為0
     * @param downloadPath 檔案下載存放的路徑，例：C:\Data。注意:請勿使用根目錄 C:\。
     * @param localId 本機作業辨識碼
     * @param nhiId IDC作業辨識碼
     */
    CNHIEiiGet(port:number,downloadPath:string,localId:string,nhiId:string): Promise<CSHISResult>;


    /** 還卡取得就醫識別碼 */
    webApiGetTreatNum(patientId:string, hospCode:string,treatDateTime:string): Promise<CSHISResultWithData<TreatNumNoICCard>>;
    /** 無卡(欠/異)取得就醫識別碼 */
    webApiGetTreatNumNoIC(patientId:string, hospCode:string): Promise<CSHISResultWithData<TreatNumNoICCard>>;
    /** 醫療資料交換平台 EII WEBAPI 上傳 */
    webApiUpload(xmlString:string,type:'A1'|'A2'|'ZZ',):Promise<{RtnCode:string,Opcode:string}>
    /** 醫療資料交換平台 EII WEBAPI 下載 */
    webApiDownload(opCode:string,type:'A1'|'A2'|'ZZ',):Promise<{
        RtnCode:string,
        Tx_result_txt:string,
        Tx_result_json:string
    }>

//底下應該是已經有被整合的方法

    /** 取得就醫序號 */
    //GetSeqNumber(cTreatItem: string, cBabyTreat: string): Promise<CSHISResultWithData<SeqNumber>>;
    /** 就醫診療資料寫入作業 */
    //WriteTreatmentCode(data: TreatmentCode): Promise<CSHISResultWithData<DocIdData>>;
    /** 就醫費用資料寫入作業 */
    //WriteTreatmentFee(data: TreatmentFee): Promise<CSHISResult>;

    /**處方箋寫入作業<br />  此函式一次寫入一組門診處方箋，若有 n 組處方箋需要寫入，則需呼叫此函式 n 次 */
    //WritePrescription(data: OutPatientPrescriptionWrite): Promise<CSHISResult>;

    /** 掛號或報到時讀取基本資料，且不檢查該 HC 卡是否有設定 PIN 保護資料隱私 */
    GetRegisterBasic2(): Promise<CSHISResultWithData<RegisterBasic2>>;

    /** 多筆處方箋寫入作業 */
    //WriteMultiPrescript(data: MultiPrescriptWrite): Promise<CSHISResult>;
    /** 處方箋寫入作業-回傳簽章*/
    //WritePrescriptionSign(data: PrescriptionSignWrite): Promise<CSHISResultWithData<string>>;
    /**
    * 取得就醫序號新版
    */
    //GetSeqNumber256(args: GetSeqNumber256): Promise<CSHISResultWithData<SeqNumber256>>;

    /**
    * 讀取就醫資料-門診處方箋
    */
    ReadPrescriptMain(iStartPos: number, iEndPos: number, iRecCount: number): Promise<CSHISResultWithData<PrescriptionMain>>;

    /**
    * 讀取就醫資料-長期處方箋
    */
    ReadPrescriptLongTerm(iStartPos: number, iEndPos: number, iRecCount: number): Promise<CSHISResultWithData<PrescriptionLongTerm>>;

    /**
    * 讀取就醫資料-重要醫令
    */
    //ReadPrescriptHVE(iStartPos: number, iEndPos: number, iRecCount: number): Promise<CSHISResultWithData<PrescriptionHVE>>;

    /**
    * 讀取就醫資料-過敏藥物
    */
    //ReadPrescriptAllergic(iStartPos: number, iEndPos: number, iRecCount: number): Promise<CSHISResultWithData<PrescriptionAllergic>>;


}

export class VisionHisDesc  {
    GetBasicData:string ='取得基本資料';
    GetRegisterBasic='掛號或報到時讀取基本資料';
    GetRegisterPrevent='預防保健掛號作業';
    GetRegisterPregnant='孕婦產前檢查掛號作業';
    GetTreatmentNoNeedHPC='讀取就醫資料不需HPC卡的部分';
    GetCumulativeFee='讀取醫療費用總累計';
    GetCumulativeData='讀取就醫累計資料';
    GetTreatmentNeedHPC='讀取就醫資料需要HPC卡的部份';
    ReadPrescription='讀取處方箋作業';
    GetInoculateData='讀取預防接種資料';
    GetOrganDonate='讀取同意器官捐贈及安寧緩和醫療註記';
    GetEmergentTel='讀取緊急聯絡電話資料';
    GetLastSeqNum='讀取最近一次就醫序號';
    GetCardStatusSAM='讀取卡片狀態(安全模組檔)';
    GetCardStatusHC='讀取卡片狀態(健保IC卡)';
    GetCardStatusHPC='讀取卡片狀態(醫事人員卡)';
    WriteNewBorn='新生兒註記寫入作業';
    WriteAllergicMedicines='過敏藥物寫入作業';
    WriteOrganDonate='同意器官捐贈及安寧緩和醫療註記寫入作業';
    WriteHealthInsurance='預防保健資料寫入作業';
    WriteEmergentTel='緊急聯絡電話資料寫入作業';
    WritePredeliveryCheckup='寫入產前檢查資料';
    DeletePredeliveryData='清除產前檢查資料';
    WriteInoculateData='預防接種資料寫入作業';
    VerifyHCPIN='驗證健保IC卡之PIN值';
    InputHCPIN='輸入健保卡PIN';
    DisableHCPIN='停用健保IC卡之Pin碼輸入功能';
    UpdateHCContents='健保IC卡卡片內容更新作業';
    OpenCom='開啟讀卡機連結埠';
    CloseCom='關閉讀卡機連結埠';
    GetCriticalIllness='讀取重大傷病註記資料';
    GetDateTime='讀取讀卡機日期時間(民國年)';
    GetCardNoSAM='讀取卡片號碼(SAM)';
    GetCardNoHC='讀取卡片號碼(健保IC卡)';
    GetCardNoHPC='讀取卡片號碼(醫事人員卡)';
    ISSetPIN='檢查健保IC卡是否設定密碼';
    UnGetSeqNumber='回復就醫資料累計值---退掛';
    UpdateHCNoReset='健保IC卡卡片內容更新作業';
    WriteAllergicNum='過敏藥物寫入指定欄位作業';
    WriteTreatmentData='就醫診療資料及費用寫入作業';
    WriteMultiPrescriptSign='多筆處方箋寫入作業-回傳簽章';
    GetCriticalIllnessID='讀取重大傷病註記資料身分比對';
    GetVersionEx='取得控制軟體版本';
    SoftwareResetCR='提供His重置讀卡機或卡片的API (讀卡機)';
    SoftwareResetSAM='提供His重置讀卡機或卡片的API (安全模組)';
    SoftwareResetHPC='提供His重置讀卡機或卡片的API (醫事人員卡)';
    SoftwareResetHC='提供His重置讀卡機或卡片的API (健保卡)';
    GetSeqNumber256N1='取得就醫序號新版-就醫識別碼';
    GetTreatNumNoICCard='異常掛號時 取得就醫識別碼';
    QuickInsurence='在保狀態查核';
    hisGetTreatNumICCard='單獨取得就醫識別碼  要插入健保卡，可配合既有 HIS 運作';
    VerifySAMDC='SAM與DC認證';
    GetHospID='讀取SAM院所代碼';
    GetHospName='讀取SAM院所名稱';
    GetHospAbbName='讀取SAM院所簡稱';
    UploadData='資料上傳';
    GetHPCStatus='取得醫事人員卡狀態';
    VerifyHPCPIN='檢查醫事人員卡之PIN值';
    InputHPCPIN='輸入新的醫事人員卡之PIN值';
    UnlockHPC='解開鎖住的醫事人員卡';
    GetHPCSN='取得醫事人員卡序號';
    GetHPCSSN='取得醫事人員卡身分證字號';
    GetHPCCNAME='取得醫事人員卡中文姓名';
    GetHPCENAME='取得醫事人員卡英文姓名';
    VHPCLogout='虛擬醫師卡登出';
    GetICD10EnC='進行疾病診斷碼押碼';
    GetICD10DeC='進行疾病診斷碼解押碼';
    GetAPIVersion='取得API版本';
    GetVPNGetRandomXAndSignX='取得健保API驗證簽章';
    GetHCACert='取得HCA憑證';
    GetHCASign='取得HCA簽章';
    InitializationAndCheckPasswd='HCA驗證醫師卡PIN';
    CNHIEiiSend='CNHIEii 資料上傳';
    CNHIEiiDownload='CNHIEii 提出醫療資料下載申請';
    CNHIEiiGet='CNHIEii 下載醫療資料';
    webApiGetTreatNum='webapi還卡取得就醫識別碼';
    webApiGetTreatNumNoIC='WebApi無卡(欠/異)取得就醫識別碼';
    webApiUpload='醫療資料交換平台 EII WEBAPI 上傳';
    webApiDownload='醫療資料交換平台 EII WEBAPI 下載';

};
